import * as React from "react"
import CategoryPC from '@modules/Category/CategoryPC'
import CategoryM from '@modules/Category/CategoryM'

const Category = (props: any) => {
  const { keyword, pathname, total, products, selectedWords, suggests, relatedArticles } = props.pageContext || {}
  return (
    <div>
      <CategoryPC pathname={pathname} suggests={suggests} selectedWords={selectedWords} products={products} total={total} keyword={keyword} relatedArticles={relatedArticles} />
      <CategoryM suggests={suggests} selectedWords={selectedWords} products={products} total={total} keyword={keyword} relatedArticles={relatedArticles} />
    </div>
  )

}
export default Category
